import {computed, reactive, ref} from "vue";

const useShipping = (siteUrl) => {

  // 編集用のユーザ情報
  const userLocal = reactive({
    zip: '',
    address: '',
    building: '',
    real_name: '',
    real_name_kana: '',
    tel: '',
  });

  // エラー情報
  const errors = ref({});

  // POST 更新のエラーを変換
  const _convertPostErrors = (_errors) => {
    // 恐らく通信途絶
    if (_errors instanceof TypeError) {
      errors.value = {'_': 'ネットワーク接続に失敗しました。'};
    }

    // 恐らく意図的な中断
    else if (_errors instanceof DOMException) {
      errors.value = {'_': 'ネットワーク接続が中断されました。'};
    }

    // 配列
    else if (Array.isArray(_errors)) {
      errors.value = {'_': _errors.join('、')};
    }

    // エラーがオブジェクトの場合
    else if (_errors instanceof Object) {
      // errors プロパティが存在した場合
      if (_errors.errors && _errors.errors instanceof Object) {
        // 値部分が文字列、または文字列の一次元配列である可能性があるので文字列に変換する
        errors.value = Object.keys(_errors.errors).reduce((acc, key) => {
          acc[key] = Array.isArray(_errors.errors[key]) ? _errors.errors[key].join('、') : _errors.errors[key];
          return acc;
        }, {});
      }

      // そうでない場合はそのまま使用
      else {
        errors.value = _errors;
      }
    }

    // エラーが文字列の場合
    else if (_errors instanceof String) {
      errors.value = {
        '_': _errors
      };
    }

    // その他の場合
    else {
      errors.value = {
        '_': _errors.toString(),
        '__': 'エラーが発生しました。',
        '___': '画面をスーパーリロードして下さい。'
      };
    }
  };

  // 送信情報を設定
  const setShipping = async (valid = false) => {
    // エラーを空にする
    errors.value = {};

    // 送信情報を作成
    const body = new FormData();
    body.append('zip', userLocal.zip);
    body.append('address', userLocal.address);
    body.append('building', userLocal.building);
    body.append('real_name', userLocal.real_name);
    body.append('real_name_kana', userLocal.real_name_kana);
    body.append('tel', userLocal.tel);

    // バリデーションのみ行う場合
    if (valid) {
      body.append('valid', '1');
    }

    // お題の取得
    try {
      // サーバに問い合わせ
      const response = await fetch(siteUrl+'mypage/shipping', {
        method: 'post',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
        },
        body
      });

      // もしエラーが発生した場合はエラーを表示
      if ( ! response.ok) {
        throw await response.json();
      }

      // 成功を返す
      return true;
    }

      // おそらくセッション切れ
    catch (e) {
      // エラーを変換
      _convertPostErrors(e);

      // 失敗を返す
      return false;
    }

    // 失敗を返す
    return false;
  };

  // ユーザ情報の更新
  const updateUserField = (payload) => {
    userLocal[payload.field] = payload.value;
  };

  // ユーザ情報の初期化
  const initUser = (data) => {
    userLocal.zip = data.zip;
    userLocal.address = data.address;
    userLocal.building = data.building;
    userLocal.real_name = data.real_name;
    userLocal.real_name_kana = data.real_name_kana;
    userLocal.tel = data.tel;
  };

  // 提供
  return {
    userLocal,
    errors,
    setShipping,
    updateUserField,
    initUser,
  };

};

//composition のエクスポート
export default useShipping;

//composition を注入するためのキー
export const USE_SHIPPING_KEY = Symbol('useShipping');
